import React from 'react';
export const CategoryCard = ({ img, link, title, }) => {
    return (React.createElement("div", { className: "w-[calc(50%-0.5rem)] mt-2 odd:mr-2 even:ml-2 cursor-pointer" },
        React.createElement("a", { href: link },
            React.createElement("img", { className: "h-32 w-full object-cover rounded", src: img, alt: "Category image" }),
            React.createElement("div", { className: "text-sm font-sans font-semibold text-dark-gray mt-2" }, title))));
};
